import { render, staticRenderFns } from "./Ventes.vue?vue&type=template&id=765c9f3f&"
import script from "./Ventes.vue?vue&type=script&lang=js&"
export * from "./Ventes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports